import { Route, Routes } from "react-router-dom";
import { CatalogMoldProvider } from "./context/CatalogMoldContext";
import { CatalogMoldPage } from "./pages/CatalogMoldPage";

type Props = {};
const CatalogMold = (props: Props) => {
  return (
    <CatalogMoldProvider>
      <Routes>
        <Route index element={<CatalogMoldPage />}></Route>
        <Route path=":moldId" element={<CatalogMoldPage />}></Route>
      </Routes>
    </CatalogMoldProvider>
  );
};
export default CatalogMold;
